(function () {
  this.VoterService = function (plugin) {
    this.plugin = plugin;
    /**
     * @type {boolean}
     */
    this.votingInProgress = false;
    /**
     * @type {HTMLElement[]}
     */
    this.voteButtons = [];

    /**
     * @param {Event} e
     * @return {void}
     */
    this.voteButtonClickHandler = function (e, element) {
      e.preventDefault();
      var id = element.getAttribute('data-id');
      var laneId = parseInt(id, 10);
      var country = element.getAttribute('data-country');
      if (
        element.classList.contains(this.plugin.Config.classNames.vote.voted)
      ) {
        this.Downvote(laneId, country);
      } else {
        this.Upvote(laneId, country);
      }
    }.bind(this);

    /**
     * @param {number} laneId
     * @param {boolean} status
     */
    this.setVotingStatus = function (laneId, status) {
      this.votingInProgress = status;
      var votingButtons = document.querySelectorAll(
        '.' +
          this.plugin.Config.classNames.vote.base +
          '[data-id="' +
          laneId +
          '"]'
      );

      for (
        var votingButtonIndex = 0;
        votingButtonIndex < votingButtons.length;
        votingButtonIndex++
      ) {
        if (status) {
          votingButtons[votingButtonIndex].classList.add(
            this.plugin.Config.classNames.vote.loading
          );
        } else {
          votingButtons[votingButtonIndex].classList.remove(
            this.plugin.Config.classNames.vote.loading
          );
        }
      }
    }.bind(this);
  };

  /**
   * @param {string} country
   * @param {string[]} excludedCountries
   * @returns {Promise<void>}
   */
  this.VoterService.prototype.UpdateVotesForCountry = function (country) {
    var sliderCountries = [];

    var countriesOnPage = document.querySelectorAll(
      '.' + this.plugin.Config.classNames.country.base
    );

    if (countriesOnPage) {
      for (
        var countryElementIndex = 0;
        countryElementIndex < countriesOnPage.length;
        countryElementIndex++
      ) {
        var countryElement = countriesOnPage[countryElementIndex];
        if (
          countryElement &&
          countryElement.dataset.countryCode &&
          countryElement.dataset.countryCode !==
            this.plugin.Config.otherCountriesId
        ) {
          sliderCountries.push(
            countryElement.dataset.countryCode.toLowerCase()
          );
        }
      }
    }

    var normalizedCountry = country.toLowerCase();
    var voteCountUrl = this.plugin.Config.apiUrl + '/vote-count/';

    if (sliderCountries.indexOf(normalizedCountry) < 0) {
      normalizedCountry = 'other';
      voteCountUrl += normalizedCountry;
      voteCountUrl += '?excluded_countries=';
      voteCountUrl += encodeURIComponent(sliderCountries.join(','));
    } else {
      voteCountUrl += normalizedCountry;
    }

    var currentCountryElement = document.querySelector(
      '.' +
        this.plugin.Config.classNames.country.base +
        '[data-country-code="' +
        normalizedCountry +
        '"]'
    );
    var loadingButtons = currentCountryElement.querySelectorAll(
      '.' + this.plugin.Config.classNames.vote.base
    );

    for (
      var buttonIndex = 0;
      buttonIndex < loadingButtons.length;
      buttonIndex++
    ) {
      loadingButtons[buttonIndex].classList.add(
        this.plugin.Config.classNames.vote.loading
      );
    }

    return fetch(voteCountUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (result) {
          if (result.data) {
            var laneIds = Object.keys(result.data);
            for (
              var laneIdIndex = 0;
              laneIdIndex < laneIds.length;
              laneIdIndex++
            ) {
              var laneId = laneIds[laneIdIndex];
              var vote = result.data[laneId];
              var lane = document.querySelector(
                '.' +
                  this.plugin.Config.classNames.slide.base +
                  '[data-id="' +
                  laneId +
                  '"]'
              );

              var valueElement;

              if (lane) {
                valueElement = lane.querySelector(
                  '.' + this.plugin.Config.classNames.vote.value
                );
                if (valueElement) {
                  valueElement.innerHTML = vote;
                }
              }

              var laneDetail = document.querySelector(
                '.' +
                  this.plugin.Config.classNames.detail.base +
                  '[data-id="' +
                  laneId +
                  '"]'
              );
              if (laneDetail) {
                valueElement = laneDetail.querySelector(
                  '.' + this.plugin.Config.classNames.vote.value
                );
                if (valueElement) {
                  valueElement.innerHTML = vote;
                }
              }
            }
          }
        }.bind(this)
      )
      .catch(
        function (e) {
          this.plugin.Logger.Debug(e);
        }.bind(this)
      )
      .finally(
        function () {
          for (
            var buttonIndex = 0;
            buttonIndex < loadingButtons.length;
            buttonIndex++
          ) {
            loadingButtons[buttonIndex].classList.remove(
              this.plugin.Config.classNames.vote.loading
            );
          }
        }.bind(this)
      );
  };

  /**
   * @param {number} id
   * @param {string} country
   * @returns {Promise<void>}
   * @throws {Error}
   */
  this.VoterService.prototype.Upvote = function (id, country) {
    var laneId = parseInt(id, 10);
    try {
      if (!laneId || laneId <= 0) {
        throw new Error('lane.invalidId');
      }

      if (this.votingInProgress) {
        throw new Error('lane.votingInProgress');
      }

      if (this.plugin.UserData.GetVotesForCountry(country)) {
        throw new Error('lane.hasVotedForCountry');
      }

      this.setVotingStatus(laneId, true);
      return fetch(
        this.plugin.Config.apiUrl + '/detail/' + laneId + '/upvote',
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }
      )
        .then(
          function (response) {
            return response.json().then(
              function (result) {
                if (result.data !== true) {
                  throw new Error('lane.votingFailed');
                }
                this.plugin.UserData.AddVote(country, laneId);
                this.UpdateCurrentVoteButtons();
                if (this.plugin.Detail.GetActiveId() === id) {
                  this.plugin.Detail.ShowThankMessage();
                }
                return this.UpdateVotesForCountry(country);
              }.bind(this)
            );
          }.bind(this)
        )
        .finally(
          function () {
            this.setVotingStatus(laneId, false);
          }.bind(this)
        );
    } catch (error) {
      this.plugin.Logger.Debug(error);
      if (this.plugin.Detail.GetActiveId() === laneId) {
        if (error.message === 'lane.hasVotedForCountry') {
          this.plugin.Detail.ShowVoted();
        } else {
          this.plugin.Detail.ShowWarning();
        }
      }
    }
  };

  /**
   * @param {number} id
   * @returns {Promise<void>}
   * @throws {Error}
   */
  this.VoterService.prototype.Downvote = function (id, country) {
    var laneId = parseInt(id, 10);
    try {
      if (!laneId || laneId <= 0) {
        throw new Error('lane.invalidId');
      }

      if (this.votingInProgress) {
        throw new Error('lane.votingInProgress');
      }

      this.setVotingStatus(laneId, true);

      return fetch(
        this.plugin.Config.apiUrl + '/detail/' + laneId + '/downvote',
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }
      )
        .then(
          function (response) {
            return response.json().then(
              function (result) {
                if (result.data !== true) {
                  throw new Error('lane.votingFailed');
                }
                this.plugin.UserData.RemoveVote(laneId);
                this.UpdateCurrentVoteButtons();
                return this.UpdateVotesForCountry(country);
              }.bind(this)
            );
          }.bind(this)
        )
        .finally(
          function () {
            this.setVotingStatus(laneId, false);
          }.bind(this)
        );
    } catch (error) {
      this.plugin.Logger.Debug(error);
      if (this.plugin.Detail.GetActiveId() === laneId) {
        this.plugin.Detail.ShowWarning();
      }
    }
  };
  /**
   * Update status of the vote button based on current user data
   *
   * @param {HTMLElement} element
   * @return {void}
   */
  this.VoterService.prototype.UpdateVoteButton = function (element) {
    var laneId = element.getAttribute('data-id');
    if (this.plugin.UserData.HasVotedForLane(laneId)) {
      element.classList.add(this.plugin.Config.classNames.vote.voted);
    } else {
      element.classList.remove(this.plugin.Config.classNames.vote.voted);
    }
  };

  /**
   * @param {string} country
   * @returns {Promise<void>}
   */
  this.VoterService.prototype.RemoveVotesFromCountry = function (country) {
    var votes = this.plugin.UserData.GetVotesForCountry(country);

    return votes.reduce(
      function (promise, vote) {
        return promise.then(
          function () {
            return this.Downvote(vote.id, country);
          }.bind(this)
        );
      }.bind(this),
      Promise.resolve()
    );
  };

  /**
   * Update status of the vote button based on current user data
   *
   * @param {HTMLElement} element
   * @return {void}
   */
  this.VoterService.prototype.UpdateCurrentVoteButtons = function () {
    for (
      var buttonIndex = 0;
      buttonIndex < this.voteButtons.length;
      buttonIndex++
    ) {
      this.UpdateVoteButton(this.voteButtons[buttonIndex]);
    }
  };

  /**
   * Registers click listener for voting button
   * @param {HTMLElement} element
   * @return {void}
   */
  this.VoterService.prototype.RegisterVoteButtonClickListener = function (
    element
  ) {
    var laneId = element.getAttribute('data-id');
    var country = element.getAttribute('data-country');
    if (!laneId) {
      this.plugin.Logger.Log('Vote button has no lane ID', element);
      return;
    }
    if (!country) {
      this.plugin.Logger.Log('Vote button has no country', element);
      return;
    }

    var found = false;
    for (
      var voteButtonIndex = 0;
      voteButtonIndex < this.voteButtons.length;
      voteButtonIndex++
    ) {
      var voteButton = this.voteButtons[voteButtonIndex];
      if (element === voteButton) {
        this.plugin.UnbindClick(element);
        found = true;
        break;
      }
    }

    if (found === false) {
      this.voteButtons.push(element);
    }

    this.UpdateVoteButton(element);

    this.plugin.BindClick(element, this.voteButtonClickHandler);
  };
}).bind(window.WorstCyclingLane)();
